/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from 'react';
import { Link, useNavigate } from "react-router";
import { useParams } from "@/commons/hooks/useParams"

import { useAuth } from '@/commons/auth';
import { Button, Modal,Spinner } from '@/commons/components';
import { isMobile } from '@/commons/utils/responsive';

import * as Layouts from "@/commons/layouts";

const RuanganTable = ({ ruanganDataList,
		 

	}) => {
  const { checkPermission } = useAuth();
  
  
  
  
  const navigate = useNavigate();
  const detail = async (ruanganItem) => {
    isMobile() && navigate(`/ruangan/${ruanganItem.id}`
    );
  };
  
  
  return (
  <>
    <Layouts.ListComponentTableLayout
  	  items={[ruanganDataList]}
  	  detail={detail}
  	  isSearchable
  	  itemsAttrs={[
          {
            id: "nama",
            condition: "",
            label: "Nama",
  		  featureName: "nama",
            editable: false
          }
  ,
          {
            id: "kapasitas",
            condition: "",
            label: "Kapasitas",
  		  featureName: "kapasitas",
            editable: false
          }
  ,
          {
            id: "keterangan",
            condition: "",
            label: "Keterangan",
  		  featureName: "keterangan",
            editable: false
          }
  ]}
        itemsEvents={(ruanganItem) => [
          
          <Link to={`/ruangan/${ruanganItem.id}`}>
            <Button
          	id="_U82AoCr7EfCz9KF7E6i0TQ"
              size="sm"
              variant=
                  "primary"
            >
              Detail
            </Button>
          </Link>
          
          
        ]}
        itemsModals={(ruanganItem) => [
        ]}
  	/>
  </>
  )
};

export default RuanganTable;
